export const roundToFirstNonZero = (number?: number, decimals: number = 2) => {
	if (!number) {
		return 0;
	}
	const log10 = number ? Math.floor(Math.log10(number)) : 0;
	const div =
		log10 < 0 ? Math.pow(10, decimals - log10 - 1) : Math.pow(10, decimals);

	return Math.round(number * div) / div;
};
